import { render, staticRenderFns } from "./FormattedCurrencyInput.vue?vue&type=template&id=05e97986&scoped=true"
import script from "./FormattedCurrencyInput.vue?vue&type=script&lang=js"
export * from "./FormattedCurrencyInput.vue?vue&type=script&lang=js"
import style0 from "./FormattedCurrencyInput.vue?vue&type=style&index=0&id=05e97986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e97986",
  null
  
)

export default component.exports